export const API_KEY = `9754364cf130d17803f95d150e75fcfc`;

export const DATA_SOURCE = `https://raw.githubusercontent.com/Theshawa/dev_help/main/countries-n-cities-list.json`;
